import React, { Component } from 'react';
import PropTypes from 'prop-types';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var PageProgress = function (_Component) {
  inherits(PageProgress, _Component);

  function PageProgress(props) {
    classCallCheck(this, PageProgress);

    var _this = possibleConstructorReturn(this, (PageProgress.__proto__ || Object.getPrototypeOf(PageProgress)).call(this, props));

    _this.componentRef = React.createRef();
    _this.watchScrolling = _this.watchScrolling.bind(_this);
    return _this;
  }

  createClass(PageProgress, [{
    key: "watchScrolling",
    value: function watchScrolling() {
      var _this2 = this;

      window.onscroll = function () {
        // console.log("scrolling....");
        var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        var _document$documentEle = document.documentElement,
            scrollHeight = _document$documentEle.scrollHeight,
            clientHeight = _document$documentEle.clientHeight;

        var height = scrollHeight - clientHeight;
        var scrolled = winScroll / height * 100;
        // document.querySelector(".progress").style.width = scrolled + "%";
        if (height > 0) {
          return _this2.componentRef.current.style.width = scrolled + "%";
        } else {
          return _this2.componentRef.current.style.width = 0;
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.watchScrolling();
      // console.log(this.myRef)
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          color = _props.color,
          height = _props.height;

      var styles = {
        progress: {
          marginTop: 0,
          padding: 0,
          background: color,
          position: "fixed",
          height: height ? height : 4,
          top: 0,
          zIndex: 99,
          transition: "width 200ms ease-out"
        }
      };
      return React.createElement(
        "div",
        null,
        React.createElement("div", { style: styles.progress, ref: this.componentRef })
      );
    }
  }]);
  return PageProgress;
}(Component);

PageProgress.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.number
};

export default PageProgress;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 19
// module chunks = 0